import { hasClass, removeClass, addClass } from '../utils/dom'

/***
 * RED_CLASS: 红色cls
 * GREEN_CLASS: 绿色cls
 * GRAY_CLASS: 灰色cls
 * @type {string}
 */
const RED_CLASS = 'red'
const GREEN_CLASS = 'green'
const GRAY_CLASS = 'gray'

/***
 * 根据不同值显示不同的数字颜色
 * @param el
 * @param binding
 */
function setColorAction (el, binding) {
  if (binding.value === false) return
  hasClass(el, RED_CLASS) && removeClass(el, RED_CLASS)
  hasClass(el, GREEN_CLASS) && removeClass(el, GREEN_CLASS)
  hasClass(el, GRAY_CLASS) && removeClass(el, GRAY_CLASS)
  if (binding.value === undefined) {
  } else {
    (+binding.value >= 0) && addClass(el, GREEN_CLASS);
    (+binding.value < 0) && addClass(el, RED_CLASS)
  }
}

export default {
  bind: setColorAction,
  update: setColorAction,
  unbind (el) {
    hasClass(el, RED_CLASS) && removeClass(el, RED_CLASS)
    hasClass(el, GREEN_CLASS) && removeClass(el, GREEN_CLASS)
    hasClass(el, GRAY_CLASS) && removeClass(el, GRAY_CLASS)
  }
}



// WEBPACK FOOTER //
// ./src/directives/color.js